<div class="my-trips">
    <div class="section-wrapper">
        <div class="left-section">
            <h2 class="p-bottom-8x">Plan your Trip</h2>
        </div>

        <div class="right-section">
            <app-upcoming-trip-empty></app-upcoming-trip-empty>
            <!-- <app-upcoming-trip-listing></app-upcoming-trip-listing> -->
        </div>
    </div>
</div>